// extracted by mini-css-extract-plugin
module.exports = {"header":"hn","headerBg":"ho"};